export default __webpack_public_path__ + "static/media/enyxa.67a592fe.png";